import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { accountTreeModel } from 'entities/account';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { translated } from 'shared/lib';
import {
	dashboardRoute,
	accountsRoute,
	cashdesksRoute,
	accountRoute,
	gameSettingsRoute,
	usersRoute,
	gamesRoute,
	accountsReportRoute,
	shiftsReportRoute,
	jackpotsRoute,
	bonusesRoute,
	vouchersRoute,
	devicesRoute,
	playersRoute,
	playersTransactionRoute,
	accountsTransactionRoute,
} from 'shared/routing';
import { NavList } from 'shared/ui';
import cls from './admin-layout-nav-list.module.scss';

const AccountancyNavLinkItem = reflect({
	view: NavList.Item,
	bind: {
		to: accountRoute,
		query: accountTreeModel.$singleSelectedNode.map((id) => (id ? { id } : null)),
		children: translated('admin-layout.accountancy'),
		'data-test-id': 'admin-layout-nav-list-accountancy-link',
	},
});

export const AdminLayoutNavList = () => {
	const { t } = useTranslation();
	const role = useUnit(viewerModel.$role);

	return (
		<nav className={cls.adminLayoutNavList}>
			<NavList.Item
				to={dashboardRoute}
				data-test-id='admin-layout-nav-list-dashboard-link'
			>
				{t('admin-layout.dashboard')}
			</NavList.Item>
			<AccountancyNavLinkItem />
			<NavList.Item
				to={accountsRoute}
				data-test-id='admin-layout-nav-list-accounts-link'
			>
				{t('admin-layout.accounts')}
			</NavList.Item>
			<NavList.Item
				to={cashdesksRoute}
				data-test-id='admin-layout-nav-list-cashdesks-link'
			>
				{t('admin-layout.cashdesks')}
			</NavList.Item>
			<NavList.Item
				to={usersRoute}
				data-test-id='admin-layout-nav-list-users-link'
			>
				{t('admin-layout.users')}
			</NavList.Item>
			<NavList.Item
				to={devicesRoute}
				data-test-id='admin-layout-nav-list-devices-link'
			>
				{t('admin-layout.devices')}
			</NavList.Item>
			<NavList.Item
				to={playersRoute}
				data-test-id='admin-layout-nav-list-players-link'
			>
				{t('admin-layout.players')}
			</NavList.Item>
			<NavList.Item
				to={gamesRoute}
				data-test-id='admin-layout-nav-list-games-link'
			>
				{t('admin-layout.games')}
			</NavList.Item>
			<NavList label={t('admin-layout.settings')}>
				<NavList.Item
					to={gameSettingsRoute}
					data-test-id='admin-layout-nav-list-game-settings-link'
				>
					{t('admin-layout.game-settings')}
				</NavList.Item>
				<NavList.Item
					to={jackpotsRoute}
					data-test-id='admin-layout-nav-list-jackpots-link'
				>
					{t('admin-layout.jackpots')}
				</NavList.Item>
				<NavList.Item
					to={bonusesRoute}
					data-test-id='admin-layout-nav-list-bonuses-link'
				>
					{t('admin-layout.bonuses')}
				</NavList.Item>
				{role === USER_ROLES.god && (
					<NavList.Item
						to={vouchersRoute}
						data-test-id='admin-layout-nav-list-vouchers-link'
					>
						{t('admin-layout.vouchers')}
					</NavList.Item>
				)}
			</NavList>
			<NavList label={t('admin-layout.transactions')}>
				<NavList.Item
					to={accountsTransactionRoute}
					data-test-id='admin-layout-accounts-transaction-link'
				>
					{t('admin-layout.accounts-transaction')}
				</NavList.Item>
				<NavList.Item
					to={playersTransactionRoute}
					data-test-id='admin-layout-players-transaction-link'
				>
					{t('admin-layout.players-transaction')}
				</NavList.Item>
			</NavList>
			<NavList label={t('admin-layout.reports')}>
				<NavList.Item
					to={accountsReportRoute}
					data-test-id='admin-layout-accounts-report-link'
				>
					{t('admin-layout.accounts-report')}
				</NavList.Item>
				<NavList.Item
					to={shiftsReportRoute}
					data-test-id='admin-layout-shifts-report-link'
				>
					{t('admin-layout.shifts-report')}
				</NavList.Item>
			</NavList>
		</nav>
	);
};
